import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { PaginatedListComponent } from './paginated-list.component';

@NgModule({
    imports: [CommonModule, TwcModule, DirectivesModule, TranslateModule],
    exports: [PaginatedListComponent],
    declarations: [PaginatedListComponent],
    providers: [],
})
export class PaginatedListModule {}
